function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState } from 'react';
import { card1Svg, card2Svg, card3Svg, card4Svg, coin } from './svg';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var cards = [{
  url: 'https://cdn.loyalie.in/1740640252841_animationCard1',
  icon: card1Svg,
  title: 'Refer your <br /> Friends',
  subTitle: 'Get 200 Pts Instantly',
  cta: 'Refer Now',
  path: '/gift-and-earn'
}, {
  url: 'https://cdn.loyalie.in/1740641319378_animationCard2',
  icon: card2Svg,
  title: 'Redeem Points  <br /> on Deals',
  subTitle: 'Get 200 Pts Instantly',
  cta: 'Redeem Now',
  path: '/deals'
}, {
  url: 'https://cdn.loyalie.in/1740641403295_animationCard3',
  icon: card3Svg,
  title: 'Complete your <br /> Profile',
  subTitle: 'Get 100 Pts Instantly',
  cta: 'Complete Now',
  path: '/myprofile/info'
}, {
  url: 'https://cdn.loyalie.in/1740641449253_animationCard4',
  icon: card4Svg,
  title: 'Give <br /> Feedback',
  subTitle: 'Get 100 Pts Instantly',
  cta: 'Give Feedback',
  path: '/contact-us'
}];
var ReloyPointsGuide = function ReloyPointsGuide(_ref) {
  var router = _ref.router;
  var history = router === null || router === void 0 ? void 0 : router.history;
  var sectionRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  useEffect(function () {
    var observer = new IntersectionObserver(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
        entry = _ref3[0];
      if (entry.isIntersecting) {
        setTimeout(function () {
          setIsVisible(true);
        }, 500);
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return function () {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    ref: sectionRef,
    className: "bg-[#F0F0F0] w-full py-10 flex flex-col items-center mt-10",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "text-center mb-6",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-center gap-2",
        children: [/*#__PURE__*/_jsx("div", {
          className: "w-16 h-[2px] bg-gray-400"
        }), /*#__PURE__*/_jsx("p", {
          className: "text-lg font-semibold text-gray-700",
          children: "How to Earn More Coins"
        }), /*#__PURE__*/_jsx("div", {
          className: "w-16 h-[2px] bg-gray-400"
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "flex justify-center mt-2",
        children: coin
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "w-full flex justify-center lg:justify-start xl:justify-center lg:overflow-x-auto lg:no-scrollbar lg:px-6 mt-4 lg:scrollbar-thin",
      children: /*#__PURE__*/_jsx("div", {
        className: "grid grid-cols-2 gap-2 md:gap-5 lg:flex lg:flex-nowrap  w-max my-2",
        children: cards.map(function (card, index) {
          return /*#__PURE__*/_jsxs("div", {
            className: "w-[170px] h-[277px] md:w-[280px] md:h-[400px] bg-cover bg-center flex flex-col justify-start items-center p-4 rounded-2xl shadow-lg text-white",
            style: {
              backgroundImage: "url(".concat(card.url, ")")
            },
            children: [/*#__PURE__*/_jsx("div", {
              className: "flex items-center mt-2 lg:mb-4 md:mt-4 w-[75px] h-[75px] md:w-[95px] md:h-[95px] transform transition-opacity duration-500 ".concat(isVisible ? 'opacity-100 animate-fadeIn animate-shake' : 'opacity-0'),
              children: card.icon
            }), /*#__PURE__*/_jsx("h2", {
              className: "text-[14px] md:text-base font-semibold text-center mt-4",
              dangerouslySetInnerHTML: {
                __html: card.title
              }
            }), /*#__PURE__*/_jsxs("p", {
              className: "text-[18px] md:text-[24px] font-bold mt-1 text-center",
              children: [card.subTitle.split(' ').slice(0, 3).join(' '), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
                className: "font-semibold text-base",
                children: card.subTitle.split(' ').slice(3).join(' ')
              })]
            }), /*#__PURE__*/_jsx("button", {
              className: "mt-2 bg-white text-black py-2 px-4 rounded-lg mb-6",
              onClick: function onClick() {
                return history.push(card.path);
              } // Navigate on button click
              ,
              children: card.cta
            })]
          }, index);
        })
      })
    })]
  });
};
export default ReloyPointsGuide;